import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '@app/common/services/api.service';
import { PortfolioCategory, PortfolioItem } from '@app/types/portfolio.types';

@Injectable({
  providedIn: 'root'
})
export class PortfolioApiService {
  private apiService = inject(ApiService);

  getPortfolioCategories(): Observable<PortfolioCategory[]> {
    return this.apiService.mpGet('/portfolio/categories');
  }

  getPortfolioItems(): Observable<PortfolioItem[]> {
    return this.apiService.mpGet('/portfolio/items');
  }

  getPortfolioItemBySlug(slug: string): Observable<PortfolioItem> {
    return this.apiService.mpGet<PortfolioItem>(`/portfolio/item/${slug}`);
  }
}
